module.exports = __webpack_public_path__ + "static/media/tw.9fffbd20.svg";